import PrivateAccessUrlComponent from 'shared/private-access-url.component';

const DisclosureModal = document.getElementById('disclosure-modal');
const DisclosureCountries = document.getElementById('disclosure-countries');
const DisclosureInvestorTypesBlock = document.getElementById('disclosure-investor-type');
const DisclosureInvestorTypes = document.getElementsByClassName('disclosure-inv-radio');
const DisclosureText = document.getElementById('disclosure-text');
const DisclosureConfirmButton = document.getElementById('disclosure-confirm');
const DisclosureDeclineButton = document.getElementById('disclosure-decline');
const DisclosureRedirectField = document.getElementById('disclosure-redirect-field');
const Html = document.getElementsByTagName('html')[0];
const DisclosureLangSwitch = document.getElementById('disclosure-lang-switch');
const DisclosureCurrentLanguage = document.getElementById('disclosure-current-lang');
let forceDisclosureModalShow = false;
let firstDisclosureShow = false;
let countriesData, DisclosureInvestorType;

const drupalLang = window.drupalSettings.path.pathPrefix;

class Disclosure {
  init() {
    if (DisclosureModal === null) {
      return;
    }
    this.updateOnChangeProfileClick();
    if (
      DisclosureModal.getAttribute('data-should-show') === '1' &&
      Disclosure.getCookie('disclosure_accepted_domain_id') === ''
    ) {
      this.fetchDisclosureForm();
      firstDisclosureShow = true;
    }

    DisclosureConfirmButton.onclick = () => {
      Disclosure.handleConfirm();
    };

    DisclosureDeclineButton.onclick = (e) => {
      e.preventDefault();
      Disclosure.handleDecline(e);
    };

    Disclosure.attachHandlerToInvestorType();

    DisclosureCountries.onchange = () => {
      Disclosure.populateInvestorTypes(Disclosure.getWholeFormData());
      jQuery('select').trigger('chosen:updated');
      this.populateDisclosureLanguage(Disclosure.getWholeFormData().countryCode);
      Disclosure.fetchContent(Disclosure.getWholeFormData());
    };

    if (Disclosure.isElementExist(DisclosureLangSwitch)) {
      DisclosureLangSwitch.onclick = (e) => {
        e.preventDefault();
        DisclosureLangSwitch.classList.add('active');
        this.handleLanguageSwitcher(e);
      };
    }

    jQuery(document).ajaxComplete(function () {
      Disclosure.attachHandlerToInvestorType();
    });
  }

  static attachHandlerToInvestorType() {
    for (const item of DisclosureInvestorTypes) {
      item.onchange = () => {
        const data = Disclosure.getWholeFormData();
        if (!this.validateData(data)) {
          item.checked = false;

          return false;
        }

        Disclosure.fetchContent(data);
      };
    }
  }

  static getWholeFormData() {
    Disclosure.getSelectedInvestorType();

    return {
      investorType: DisclosureInvestorType,
      countryCode: DisclosureCountries.value.toString(),
    };
  }

  static getSelectedInvestorType() {
    DisclosureInvestorType = null;

    Object.entries(DisclosureInvestorTypes).forEach(([key, input]) => {
      if (input.checked) {
        DisclosureInvestorType = input.value.toString();
      }
    });
    if (!Disclosure.isElementExist(DisclosureInvestorType) && Disclosure.isElementExist(countriesData)) {
      DisclosureInvestorType = countriesData[DisclosureCountries.value.toString()].defaultInvestorTypeId;
    }
  }

  static validateData(data) {
    if (
      countriesData.hasOwnProperty(data.countryCode) &&
      countriesData[data.countryCode].hasOwnProperty('redirectInvestorType') &&
      countriesData[data.countryCode].redirectInvestorType.hasOwnProperty(data.investorType)
    ) {
      window.location.href = countriesData[data.countryCode].redirectInvestorType[data.investorType];

      return false;
    }

    return true;
  }

  static fetchContent(data) {
    const formData = new FormData();
    const lang = Disclosure.getCurrentLangOnSwitcher(true);

    if (Disclosure.isElementExist(data)) {
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    jQuery.ajax({
      method: 'POST',
      url: `${lang}/disclosure/content`,
      data: formData,
      processData: false,
      contentType: false,
      headers: {
        credentials: 'same-origin',
      },
      success: (response) => {
        if (lang) {
          Disclosure.translateInterfaceStrings(response);
        }
        Disclosure.handleContentFromResponse(response);
      },
    });
  }

  static getCurrentLangUrlPrefix() {
    let prefix = window.drupalSettings.path.currentLanguageUrlPrefix;

    if (prefix !== '') {
      prefix = '/' + prefix;
    }

    return prefix;
  }

  fetchDisclosureForm(lang = Disclosure.getCurrentLangOnSwitcher(true)) {
    jQuery.ajax({
      method: 'POST',
      url: `${lang}/disclosure/get-form-values${window.location.search}`,
      processData: false,
      contentType: false,
      headers: {
        credentials: 'same-origin',
      },
      success: (response) => {
        if (response.shouldShow || forceDisclosureModalShow === true) {
          jQuery(window).off('scroll.views_infinite_scroll');
          this.handleFormValuesFromResponse(response);
          Disclosure.handleContentFromResponse(response);

          if (firstDisclosureShow) {
            window.setTimeout(function () {
              utag.ext.gdprConsentBannerPrompt();
            }, 500);
          }
        }
        firstDisclosureShow = false;
      },
    });
  }

  static getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  static setCookie(cname, cvalue) {
    var date = new Date();
    date.setDate(date.getDate() + 365);
    document.cookie =
      encodeURIComponent(cname) + '=' + encodeURIComponent(cvalue) + '; expires=' + date.toUTCString() + '; path=/';
  }

  updateOnChangeProfileClick() {
    const links = document.getElementsByClassName('change-profile-link');
    const updateChangeProfile = (e) => {
      e.preventDefault();
      this.fetchDisclosureForm();
      forceDisclosureModalShow = true;
    };

    for (let i = 0; i < links.length; i++) {
      links[i].onclick = updateChangeProfile;
    }
  }

  handleFormValuesFromResponse(response) {
    countriesData = response.countryData;
    const currentCountryCode = response.currentCountryCode;

    Disclosure.populateCountries(currentCountryCode);
    Disclosure.populateInvestorTypes({
      countryCode: currentCountryCode,
      investorType: response.currentInvestorType,
    });
    this.populateDisclosureLanguage(currentCountryCode);
  }

  static handleContentFromResponse(response) {
    Disclosure.handleMessage(response);
    new PrivateAccessUrlComponent().updateLinks(response.encoded);
    jQuery('#userNavigation').collapse('hide');
    jQuery('#mainNavigation').collapse('hide');
    jQuery('select').trigger('chosen:updated');

    Drupal.behaviors.chosen.attach();
  }

  static handleMessage(message) {
    DisclosureModal.style.display = 'flex';
    Html.classList.add('body--disclosure-visible');
    if (message.redirect) {
      DisclosureRedirectField.style.display = 'block';
    }

    Disclosure.populateText(message.content);
  }

  handleLanguageSwitcher(e) {
    const href = e.target.getAttribute('href');
    if (Disclosure.isElementExist(href) && href.length) {
      DisclosureCurrentLanguage.innerText = e.target.getAttribute('data-code');
      DisclosureCurrentLanguage.dataset.langname = e.target.firstChild.nodeValue;
      Disclosure.fetchContent(Disclosure.getWholeFormData());
    }
    if (
      Disclosure.isElementExist(e.target.closest('.block--language')) &&
      DisclosureLangSwitch.classList.contains('active')
    ) {
      DisclosureLangSwitch.classList.remove('active');
    }
  }

  static populateText(content) {
    DisclosureText.innerHTML = content;
  }

  static populateInvestorTypes(data) {
    const selectedCountry = data.countryCode;
    const selectedInvestorType = data.investorType;
    countriesData = Disclosure.isElementExist(data.countriesData) ? data.countriesData : countriesData;
    const availableInvestorTypes = countriesData[selectedCountry].availableInvestorTypes;
    DisclosureInvestorTypesBlock.innerText = '';
    DisclosureInvestorTypesBlock.parentElement.style.display =
      Object.getOwnPropertyNames(availableInvestorTypes).length <= 1 ? 'none' : 'inherit';

    Object.entries(countriesData[selectedCountry].availableInvestorTypes).forEach(([key, value]) => {
      key = key.trim();

      const input = Disclosure.createRadioButtonElement(key, value, selectedInvestorType);

      DisclosureInvestorTypesBlock.append(input);
    });
  }

  static createRadioButtonElement(key, value, selectedInvestorType) {
    const inputWrapper = document.createElement('div');
    inputWrapper.className = 'form-item form-type-radio form-item-investor-type col-md-6';

    const label = document.createElement('label');
    label.className = 'option';
    label.innerText = value;
    label.setAttribute('for', `investor-type-${key}`);

    const input = document.createElement('input');
    input.setAttribute('type', 'radio');
    input.className = 'form-radio disclosure-inv-radio';
    input.id = `investor-type-${key}`;
    input.value = key;
    input.name = 'disclosure_investor_type';

    if (selectedInvestorType && selectedInvestorType.toString() === key) {
      input.setAttribute('checked', 'checked');
    }

    inputWrapper.append(input);
    inputWrapper.append(label);

    return inputWrapper;
  }

  static populateCountries(selectedCountry) {
    DisclosureCountries.innerText = '';
    Object.entries(countriesData).forEach(([key, item]) => {
      const option = document.createElement('option');
      option.value = key;
      option.text = item.countryName;

      if (selectedCountry.toString() === key.toString()) {
        option.selected = true;
      }

      DisclosureCountries.add(option);
    });
    jQuery('select').trigger('chosen:updated');
  }

  static isElementExist(el) {
    return el !== null && el !== undefined;
  }

  populateDisclosureLanguage(countryCode) {
    if (Disclosure.isElementExist(DisclosureLangSwitch) && Disclosure.isElementExist(countryCode)) {
      const languages = countriesData[countryCode].availableLanguages;

      Disclosure.updateLangSwitcher(languages);

      const availableLanguages = Object.entries(languages);

      if (availableLanguages.length <= 1) {
        DisclosureLangSwitch.style.display = 'none';
        document.getElementById('disclosure-title').classList.remove('lang-switcher-exist');
      } else {
        DisclosureLangSwitch.style.display = 'block';
        document.getElementById('disclosure-title').classList.add('lang-switcher-exist');
      }
    }
  }

  static translateInterfaceStrings(data) {
    const text = data.strings;

    if (Disclosure.isElementExist(text)) {
      document.getElementById('disclosure-subtitle').innerText = text.subtitle;
      document.getElementById('disclosure-country-label').innerText = text.countrySwitcher;
      document.getElementById('disclosure-investor-type-label').innerText = text.investorTypeSwitcher;
      document.getElementById('disclosure-confirm').innerText = text.btnConfirm;
      document.getElementById('disclosure-decline').innerText = text.btnDecline;
    }

    Disclosure.populateInvestorTypes({
      countryCode: data.currentCountryCode,
      investorType: data.currentInvestorType,
      countriesData: data.countryData,
    });

    Disclosure.populateCountries(data.currentCountryCode);
    Disclosure.updateLangSwitcher(data.countryData[data.currentCountryCode].availableLanguages);
  }

  static getCurrentLangOnSwitcher(prefix = false) {
    let langCode = window.drupalSettings.path.currentLanguageUrlPrefix;

    if (Disclosure.isElementExist(DisclosureLangSwitch)) {
      const links = DisclosureLangSwitch.querySelectorAll('a');
      let langName = DisclosureCurrentLanguage.dataset.langname;
      langCode = DisclosureCurrentLanguage.innerText.trim().toLowerCase();

      if (links.length) {
        let currentLang;

        links.forEach((link) => {
          langName = link.innerText.trim();

          if (langName === currentLang) {
            langCode = link.dataset.code;
          }
        });
      }
    }

    if (this.isElementExist(langCode) && langCode.length) {
      return prefix ? '/' + langCode : langCode;
    }

    return '';
  }

  static updateLangSwitcher(availableLanguages) {
    let currentLang;

    if (Disclosure.isElementExist(DisclosureLangSwitch)) {
      currentLang = Disclosure.getCurrentLangOnSwitcher();
      const langMenu = DisclosureLangSwitch.getElementsByTagName('ul');
      langMenu[0].innerHTML = '';

      Object.entries(availableLanguages).forEach(([key, value]) => {
        key = key.trim();
        const langItem = document.createElement('li');
        const link = document.createElement('a');

        link.setAttribute('href', '/' + key + '?lang=' + key);
        link.innerText = value;
        link.dataset.code = key;
        langItem.append(link);
        langMenu[0].append(langItem);
      });

      if (!availableLanguages[currentLang]) {
        currentLang = Object.entries(availableLanguages)[0][0];
      }
    }

    if (currentLang.length > 0) {
      DisclosureCurrentLanguage.innerText = currentLang;
    }
  }

  static getLanguageCodeFromHref(link) {
    if (link) {
      return new RegExp(`[^=]*$`).exec(link.getAttribute('href'))[0];
    }
  }

  static handleConfirm() {
    forceDisclosureModalShow = false;
    const lang = Disclosure.getCurrentLangOnSwitcher(true);
    const data = Disclosure.getWholeFormData();
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    jQuery.ajax({
      method: 'POST',
      url: `${lang}/disclosure/accept`,
      data: formData,
      processData: false,
      contentType: false,
      success: () => {
        if (lang) {
          Disclosure.setCookie('lang', lang.replace('/', ''));
        }
        if (window.location.search !== '') {
          const cleanSearchString = window.location.search
            .replace(/[&|?](access-group-key|country|page)=[^&]+/gi, '')
            .replace(/^&/, '?');
          if (cleanSearchString !== '') {
            window.location.search = cleanSearchString;
          } else {
            window.location.href = window.location.href.replace(/\?.*/, '');
          }
          document.location.reload();
        } else if (lang && lang.replace('/', '') !== drupalLang.replace('/', '')) {
          document.location = lang + '/' + window.drupalSettings.path.currentPath;
        } else {
          document.location.reload();
        }
      },
    });
  }

  static handleDecline(e) {
    const href = e.target.href;
    forceDisclosureModalShow = true;
    const lang = Disclosure.getCurrentLangOnSwitcher(true);

    jQuery.ajax({
      method: 'POST',
      url: `${lang}/disclosure/decline`,
      data: null,
      processData: false,
      contentType: false,
      success: () => {
        if (href) {
          window.location.replace(href);
        } else {
          window.location.reload();
        }
      },
    });
  }
}

export default Disclosure;
